let user = window.sessionStorage.getItem('user') ? JSON.parse(window.sessionStorage.getItem('user')) : {
  innerid: '',
  loginToken: '',
  loginname: '',
  logourl: '',
  mobile: '',
  name: '',
  nickname: '',
  isLogin: false,
  zjmemtype: 0
}
let errorMsg = window.sessionStorage.getItem('errorMsg') ? JSON.parse(window.sessionStorage.getItem('errorMsg')) : {
  error404: '',
  error504: '很抱歉，当前页面无效'
}
let eid = window.sessionStorage.getItem('eid') ? JSON.parse(window.sessionStorage.getItem('eid')) : ''

let domainlist = {
    //PC端域名-生产 capwhale
	url_news: window.location.hostname.indexOf('capwhale.com')>-1?'https://www.capwhale.com':'http://www.zj178.com',
    url_course:  window.location.hostname.indexOf('capwhale.com')>-1?'https://ke.capwhale.com':'http://ke.zj178.com',
    url_report:  window.location.hostname.indexOf('capwhale.com')>-1?'https://report.capwhale.com':'http://report.zj178.com',
    url_my:  window.location.hostname.indexOf('capwhale.com')>-1?'https://my.capwhale.com':'http://my.zj178.com',
    url_gj:  window.location.hostname.indexOf('capwhale.com')>-1?'https://gj.capwhale.com':'http://gj.zj178.com',
    url_live:  window.location.hostname.indexOf('capwhale.com')>-1?'https://live.capwhale.com':'http://live.zj178.com',
    url_hr:  window.location.hostname.indexOf('capwhale.com')>-1?'https://hr.capwhale.com':'http://hr.zj178.com',
    url_hd:  window.location.hostname.indexOf('capwhale.com')>-1?'https://hd.capwhale.com':'http://hd.zj178.com',
    url_czadmin:  window.location.hostname.indexOf('capwhale.com')>-1?'https://czadmin.capwhale.com':'http://czadmin.zj178.com',

    //PC端域名-本地
    // url_news: 'http://192.168.10.136:6002/pindex',
    // url_course: 'http://192.168.10.136:6002',
    // url_report: 'http://192.168.10.136:6002/reportindex',
    // url_my: 'http://192.168.10.136:6002/me',
    // url_gj: 'http://192.168.10.136:6002/gjindex',
    // url_live: 'http://192.168.10.136:6002/liveingindex',
    // url_hr: 'http://192.168.10.136:6002/talentindex',
    // url_hd: 'http://192.168.10.136:6002/hdindex', 
    
    //移动端域名-生产 capwhale
    url_news_m: window.location.hostname.indexOf('capwhale.com')>-1?'https://m.capwhale.com':'http://m.zj178.com',
    url_course_m: window.location.hostname.indexOf('capwhale.com')>-1?'https://ke.capwhale.com/m/mindex':'http://ke.zj178.com/m/mindex',
    url_report_m: window.location.hostname.indexOf('capwhale.com')>-1?'https://report.capwhale.com/m/mreportindex':'http://report.zj178.com/m/mreportindex',
    url_my_m: window.location.hostname.indexOf('capwhale.com')>-1?'https://my.capwhale.com/m/me':'http://my.zj178.com/m/me',
    url_gj_m: window.location.hostname.indexOf('capwhale.com')>-1?'https://gj.capwhale.com/m/mgjindex':'http://gj.zj178.com/m/mgjindex',
    url_live_m: window.location.hostname.indexOf('capwhale.com')>-1?'https://live.capwhale.com/m/mliveindex':'http://live.zj178.com/m/mliveindex',
    url_hr_m: window.location.hostname.indexOf('capwhale.com')>-1?'https://hr.capwhale.com/m/mtalentindex':'http://hr.zj178.com/m/mtalentindex',
    url_hd_m: window.location.hostname.indexOf('capwhale.com')>-1?'https://hd.capwhale.com/m/mkaa/index':'http://hd.zj178.com/m/mkaa/index',

    
    //移动端域名-本地
    // url_course_m: 'http://192.168.10.152:6001/m/mindex',
    // url_report_m: 'http://192.168.10.152:6001/m/mreportindex',
    // url_my_m: 'http://192.168.10.152:6001/m/me',
    // url_gj_m: 'http://192.168.10.152:6001/m/mgjindex',
    // url_live_m: 'http://192.168.10.152:6001/m/mliveindex',
    // url_hr_m: 'http://192.168.10.152:6001/m/mtalentindex',
    // url_hd_m: 'http://192.168.10.152:6001/m/mkaa/index'
}

//域名和浏览器信息
let domainInfo = {
  //是否移动端 1移动端 0非移动端
  isMobile: navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) ? 1 : 0,
  //是否课程域名
  isCourseDomain: window.location.hostname.indexOf('ke.capwhale.com') > -1 ? 1 : 0,
  //是否报告域名
  isReportDomain: window.location.hostname.indexOf('report.capwhale.com') > -1 ? 1 : 0,
  //是否个人中心域名
  isMyDomain: window.location.hostname.indexOf('my.capwhale.com') > -1 ? 1 : 0,
  //是否股鲸域名
  isShareWhaleDomain: window.location.hostname.indexOf('gj.capwhale.com') > -1 ? 1 : 0,
  //是否直播域名
  isLiveDomain: window.location.hostname.indexOf('live.capwhale.com') > -1 ? 1 : 0,
  //是否猎聘域名
  isHRDomain: window.location.hostname.indexOf('hr.capwhale.com') > -1 ? 1 : 0,
  //是否活动域名
  isHDDomain: window.location.hostname.indexOf('hd.capwhale.com') > -1 ? 1 : 0,
  //是否zj178域名
  isZJ178Domain: window.location.hostname.indexOf('zj178.com') > -1 ? 1 : 0
}

// 渠道id
let channelid = sessionStorage.channelid ? sessionStorage.channelid : ''

const state = {
  loading: false, // 加载动画
  loginPop: false, // 登录注册弹窗,
  user: user, // 用户信息
  eid: eid, // 签到数据id
  page: { // 分页
    page: 1,
    pagesize: 10
  },
  ClientType: 1, // 客户端类型 1PC 2移动 3微信 4小程序 5App
  errorMsg: errorMsg,
  noDataTip: '',
  refresh: false, // 是否刷新
  domainlist: domainlist,
  domainInfo: domainInfo, //域名和浏览器信息
  isInit: false, // 是否初始化
  aaEnrollment: false, // 是否显示报名用户选择框
  initAaEnrollment: false, // 刷新报名用户选择框
  aaEnrollmentList: [], // 报名用户列表
  channelid: channelid,
  topicQuesBankConfiguration: [ // 专题考试和其科目配置
      {
          code: 'jjcy',
          name: '基金从业',
          subjectcode: [
              {id: '5701', name: '基金法律法规'},
              {id: '5702', name: '证券投资基金基础知识'},
              {id: '5703', name: '私募股权投资基金基础知识'}
          ]
      },
      {
        code: 'bjr',
        name: '保荐代表人',
        subjectcode: [
          {id: '6201', name: '投资银行业务'}
        ]
      }
  ],
  topicQuesBankSectionConfiguration: [ // 专题考试版块配置
    {code: '0101', name: '章节练习'},
    {code: '0102', name: '历年真题'},
    {code: '0103', name: '模拟试题'},
    {code: '0104', name: '易错题'}
  ],
  specialConfiguration: {
    fundsFrom: {
        name: '基金从业资格',
        nextExamDate: '2021-03-27',
        nextExamDateStr: '预计十二月公布',
        applyDateStr: '考前1-2个月',
        applyBeginDate: '2021-01-27',
        applyEndDate: '2021-03-26',
        admissionTicketDateStr: '考前一周内',
        admissionTicketBeginDate: '2021-03-20',
        admissionTicketEndDate: '2021-03-20',
        checkGradeDateStr: '考后一周内',
        checkGradeBeginDate: '2021-04-28',
        checkGradeEndDate: '2021-04-03',
        certificateDateStr: '考后7个工作日',
        certificateBeginDate: '2021-03-29',
        certificateEndDate: '2021-04-06'
    }
  },
  // app提示
  showAppTips: true,

  // 专题题库购买弹窗
  specialTopicBuyDialogVisible: false
}
export default state